module.exports = __webpack_public_path__ + "static/media/faucet-drip.e38853dc.svg";